/**
 * 비상벨 — /bell (2026-07-19 메뉴 재구성으로 영업진행현황 탭에서 독립 승격).
 *
 * 내용은 기존 EmergencyBellTab 그대로 (상태 필터·납기 경고·엑셀·납기현황 PDF·등록/수정).
 * 권한: sales+ (viewer 는 메뉴 숨김 + ViewerBlocked — 기존 탭 노출 조건과 동일).
 */

import { EmergencyBellTab } from '../components/EmergencyBellTab';

export function EmergencyBellPage() {
  return (
    <div className="p-8">
      <h1 className="ui-page-title mb-3">비상벨</h1>
      <EmergencyBellTab />
    </div>
  );
}
